import { ShiftPageProps, WaitingShiftPageViews, EventTypeOption } from '../types'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { BigButtonSection } from '../../../components/layout'
import { Button } from '../../../components/Button'
import { AddEventPage } from '../AddEvent'
import { ShiftTable } from '../../../components/ShiftTable'
import { ShiftHeader, ShiftHeading } from '../../../components/ShiftTable/layout'
import { messages } from '../messages'

export const WaitingPage: React.FunctionComponent<ShiftPageProps> = ({ currentShift, refetch }) => {
  const [view, setView] = useState<WaitingShiftPageViews>(WaitingShiftPageViews.default)
  const { formatMessage } = useIntl()
  return (
    <>
      {view === WaitingShiftPageViews.default && (
        <>
          <ShiftHeader color="red300">
            <ShiftHeading label={formatMessage(messages.waitStatus)} />
            <BigButtonSection>
              <Button
                category="new"
                label={formatMessage(messages.endWait)}
                onClick={() => setView(WaitingShiftPageViews.wait_end_form)}
                size="m"
                fontWeight="normal"
              />
            </BigButtonSection>
          </ShiftHeader>
          <ShiftTable shift={currentShift} />
        </>
      )}

      {view === WaitingShiftPageViews.wait_end_form && (
        <AddEventPage
          type={EventTypeOption.wait_end}
          onClose={() => setView(WaitingShiftPageViews.default)}
          shift={currentShift}
          refetch={refetch}
        />
      )}
    </>
  )
}
